import * as React from 'react'
import { Text, Block, Button } from '$views/components'
import { Formik, Form, Field } from 'formik'
import { CaresField } from '$views/RecommendationsForms/ResidenceForm/CareStep/components/CaresField'
import companionshipIcon from '$icons/companionship.svg'
import cleanessIcon from '$icons/cleaness.svg'
import sanityAttentionIcon from '$icons/sanityAttention.svg'
import transportIcon from '$icons/transport.svg'
import { draft } from '$utils/services/formDraftService'
import { residenceFormDraftName, ResidenceFormSteps } from '$views/RecommendationsForms/ResidenceForm/ResidenceForm'
import { Textarea } from '$views/components/Forms/Textarea'
import { tagManager } from '$infrastructure/tagManager/tagManager'

interface Props {
  onNextStep: () => void
  onPreviousStep: () => void
}

const careOptions = [
  {
    key: 'companionship',
    value: 'Compañia',
    icon: companionshipIcon,
  },
  {
    key: 'cleaness',
    value: 'Aseo',
    icon: cleanessIcon,
  },
  {
    key: 'sanityAttention',
    value: 'Atención sanitaria',
    icon: sanityAttentionIcon,
  },
  {
    key: 'transport',
    value: 'Transporte',
    icon: transportIcon,
  },
]
export const CareStep: React.FC<Props> = ({ onNextStep, onPreviousStep }) => {
  const getInitialValues = () => draft.get(residenceFormDraftName)[ResidenceFormSteps.careStep]
  const updateDraft = event => {
    const careDraftValues = draft.get(residenceFormDraftName)[ResidenceFormSteps.careStep]
    if (event.target.type === 'checkbox') {
      draft.set(residenceFormDraftName, {
        [ResidenceFormSteps.careStep]: { ...careDraftValues, [event.target.name]: event.target.checked },
      })
    }
    if (event.target.type === 'textarea') {
      draft.set(residenceFormDraftName, {
        [ResidenceFormSteps.careStep]: { ...careDraftValues, [event.target.name]: event.target.value },
      })
    }
  }

  const onSubmit = () => {
    tagManager.push({
      event: 'completeform',
      serviceType: 'Corto',
      offerType: 'recomendación',
    })
    onNextStep()
  }

  return (
    <>
      <Text title>4. Tareas</Text>
      <Text marginTop="base" marginBottom="small">
        Seleccione una o varias ayudas que requiere la persona a cuidar
      </Text>
      <Formik
        initialValues={getInitialValues()}
        onSubmit={onSubmit}
        render={() => (
          <Form>
            <Field component={CaresField} options={careOptions} onBlur={updateDraft} />
            <Text subheader marginTop="small">
              Información adicional
            </Text>
            <Text marginTop="base" marginBottom="mini">
              Indícanos cualquier información que consideres relevante
            </Text>
            <Field
              name="extraInformation"
              placeholder={'La residente Paula, que es alérgica a...'}
              component={Textarea}
              onBlur={updateDraft}
              maxLength={250}
            />
            <Block flex marginTop="medium">
              <Block marginRight="base">
                <Button primary bordered onClick={onPreviousStep}>
                  Volver
                </Button>
              </Block>
              <Button primary fluid type="submit">
                Siguiente
              </Button>
            </Block>
            <Text marginTop="mini" color="menu" textAlign="center">
              Paso 4/4
            </Text>
          </Form>
        )}
      />
    </>
  )
}



// WEBPACK FOOTER //
// ./src/views/RecommendationsForms/ResidenceForm/CareStep/CareStep.tsx